/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_Delete_ConfirmInputs */

const en_options_api_keys_delete_confirm = /** @type {(inputs: Options_Api_Keys_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete this key?`)
};

const fr_options_api_keys_delete_confirm = /** @type {(inputs: Options_Api_Keys_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voulez-vous vraiment supprimer cette clé ?`)
};

const de_options_api_keys_delete_confirm = /** @type {(inputs: Options_Api_Keys_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sind Sie sicher, dass Sie diesen Schlüssel löschen möchten?`)
};

const it_options_api_keys_delete_confirm = /** @type {(inputs: Options_Api_Keys_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sei sicuro di voler eliminare questa chiave?`)
};

const ru_options_api_keys_delete_confirm = /** @type {(inputs: Options_Api_Keys_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы уверены, что хотите удалить этот ключ?`)
};

const es_options_api_keys_delete_confirm = /** @type {(inputs: Options_Api_Keys_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Está seguro de que desea eliminar esta clave?`)
};

const zh_cn2_options_api_keys_delete_confirm = /** @type {(inputs: Options_Api_Keys_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您确定要删除此密钥吗？`)
};

const ja_options_api_keys_delete_confirm = /** @type {(inputs: Options_Api_Keys_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このキーを削除してもよろしいですか?`)
};

const hi_options_api_keys_delete_confirm = /** @type {(inputs: Options_Api_Keys_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्या आप वाकई इस कुंजी को हटाना चाहते हैं?`)
};

const pt_pt2_options_api_keys_delete_confirm = /** @type {(inputs: Options_Api_Keys_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tem certeza de que deseja excluir esta chave?`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to delete this key?" |
*
* @param {Options_Api_Keys_Delete_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_delete_confirm = /** @type {((inputs?: Options_Api_Keys_Delete_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_Delete_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_api_keys_delete_confirm(inputs)
	if (locale === "de") return de_options_api_keys_delete_confirm(inputs)
	if (locale === "it") return it_options_api_keys_delete_confirm(inputs)
	if (locale === "ru") return ru_options_api_keys_delete_confirm(inputs)
	if (locale === "es") return es_options_api_keys_delete_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_options_api_keys_delete_confirm(inputs)
	if (locale === "ja") return ja_options_api_keys_delete_confirm(inputs)
	if (locale === "hi") return hi_options_api_keys_delete_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_options_api_keys_delete_confirm(inputs)
	return en_options_api_keys_delete_confirm(inputs)
});